/* Excel Point No 4 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdfProgramStatusReportViewComponent } from './pdf-program-status-report-view.component';

const routes: Routes = [
  {
    path: '',
    component: PdfProgramStatusReportViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfProgramtStatusReportViewRoutingModule { }
/* Excel Point No 4 */
